var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"GameHeader"},[_c('span',{staticClass:"BackButton",class:{'u-hidden': !_vm.showBackButton},on:{"click":_vm.backClicked}},[_vm._v(" <--- ")]),_c('h1',{staticClass:"GameTitle"},[_vm._v(" codeBreaker_> ")]),_c('span',{staticClass:"HelpButton",class:{'u-hidden': !_vm.showHelpButton},on:{"click":_vm.helpClicked}},[_vm._v(" ? ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }